import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import WarningIcon from '@public/assets/common/icons/warningIcon.svg';
import styles from './CouponBetsHistoryEmpty.module.scss';
const CouponBetsHistoryEmpty: FC = () => {
  const {
    t
  } = useTranslation('sport');
  return <div className={styles.root} data-sentry-component="CouponBetsHistoryEmpty" data-sentry-source-file="CouponBetsHistoryEmpty.tsx">
      <WarningIcon className={styles.icon} data-sentry-element="WarningIcon" data-sentry-source-file="CouponBetsHistoryEmpty.tsx" />
      <p className={styles.text}>{t('coupon.history.no_available_coupons', "You don't have available coupons")}</p>
    </div>;
};
export { CouponBetsHistoryEmpty };